import httpService from "../../Service/httpService";

const controller = "Catalogos";

export const getNaciones = async () => {
	const res = await httpService.get(`/${controller}/getNaciones`);
	return res.data;
}

export const getEntidades = async () => {
	const res = await httpService.get(`/${controller}/getEstados`);
	return res.data;
}

export const getMunicipios = async (idEntidad) => {
	const res = await httpService.get(`/${controller}/getMunicipios/${idEntidad}`);
	return res.data;
}

export const getFormaciones = async () => {
	const res = await httpService.get(`/${controller}/getFormaciones`);
	return res.data;
}

export const getReligiones = async () => {
	const res = await httpService.get(`/${controller}/getReligiones`);
	return res.data;
}

export const getRequisitos = async (id) => {
	const res = await httpService.get(`/${controller}/getRequisitos/${id}`);
	return res.data;
}

export const getDocsEntregados = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getDocsEntregados/${id}/${idPac}`);
	return res.data;
}




